import { render, staticRenderFns } from "./chat-message-item.vue?vue&type=template&id=1825ee6e&scoped=true&"
import script from "./chat-message-item.vue?vue&type=script&lang=js&"
export * from "./chat-message-item.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-item.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chat-message-item.vue?vue&type=style&index=1&id=1825ee6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825ee6e",
  null
  
)

export default component.exports